import React from 'react';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';

import H3 from './styledComponents/H3';
import IdeaGeneral from './styledComponents/IdeaGeneral';
import ChapterSpace from './styledComponents/ChapterSpace';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,ParentAnchor } from './blockComponents';
import { PlainImage } from './imageComponents';

function Merch({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
    return (
        <ParentAnchor
            key='merchSection'
            blockId="merch-section"
            blockName='merchSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_7' })} downloadLink="https://drive.google.com/drive/folders/1zzj6uCTS0EZ2_SAlozeTO_d64DGFzATt?usp=sharing"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <IdeaGeneral space="Top"><FormattedHTMLMessage id="merch_1" /></IdeaGeneral>
                        <AnchorBlock
                            key='tshirtsBlock'
                            blockName='tshirtsBlock'
                            blockId='t-shirts'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'merch_1_1' })}</H3>
                            <PlainImage src="merch/shirt-3@2x.jpg" alt="" />
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="merch/shirt-1@2x.jpg" last="xs" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="merch/shirt-2@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='capsBlock'
                            blockName='capsBlock'
                            blockId='caps'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'merch_1_2' })}</H3>
                            <PlainImage src="merch/Cap@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                        <AnchorBlock
                            key='cupsBlock'
                            blockName='cupsBlock'
                            blockId='cups'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'merch_1_3' })}</H3>
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="merch/Cup1@2x.jpg" last="xs" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="merch/Cup2@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='bitsBlock'
                            blockName='bitsBlock'
                            blockId='bits'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'merch_1_4' })}</H3>
                            <PlainImage src="merch/bita-Bite@2x.jpg" alt="" />
                            <PlainImage src="merch/bita-Bite2@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                        <AnchorBlock
                            key='tapeBlock'
                            blockName='tapeBlock'
                            blockId='tape'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'merch_1_5' })}</H3>
                            <PlainImage src="merch/stripe@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                        <AnchorBlock
                            key='bagBlock'
                            blockName='bagBlock'
                            blockId='bag'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'merch_1_6' })}</H3>
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="merch/pack-1@2x.jpg" last="xs" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="merch/pack-2@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
    )
}

export default injectIntl(Merch)